export default __webpack_public_path__ + "static/media/bards.52190aab.PNG";